import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import clsx from "clsx";

interface DropdownSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  addStyle?: string;
}

const DropdownSelect: React.FC<DropdownSelectProps> = ({
  value,
  onChange,
  options,
  addStyle,
}) => {
  const handleDropdownChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
  };

  return (
    <Select
      value={value}
      onChange={handleDropdownChange}
      sx={{
        color: "#2C2C2C", 
        paddingRight: "16px",
        '& .MuiSelect-select': {
          fontSize: "14px"
        }
      }}
      className={clsx(
        "dropdown-select",
        "!font-inter",
        "!h-[48px]",
        "border-transparent",
        "!text-[14px]",
        addStyle
      )}
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        PaperProps: {
          sx: {
            ".MuiMenuItem-root": {
              height: "36px",
              fontFamily: "inter, sans-serif",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "#F4F8F9 !important",
              },
            },
            ".MuiMenuItem-root.Mui-selected": {
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "#F4F8F9 !important",
              },
            },
          },
        },
      }}>
      {options.map((option, index) => (
        <MenuItem
          key={`${option}-${index}`}
          value={option}
          className="!font-inter">
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropdownSelect;
